import React from 'react';

const NotFound = () => {
    return (
        <div style={{display:"flex", marginTop: "50%", justifyContent: "center"}}>
            <div>
            <h3 style={{color: "red"}}>Ohho! This page is not Found</h3>
            <br />
            <h1>404</h1>
            </div>

        </div>
    );
};

export default NotFound;